import { getLocale } from "../runtime";

const sv_easteregg1 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ta en stund att andas djupt. Även omvägar kan vara en del av resan.`
};

const easteregg1 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_easteregg1(inputs)
	return "easterEgg1";
};

export { easteregg1 as "easterEgg1" };